import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';

// Initialize Firebase (this will also initialize Analytics)
import './firebase/config';

// Create a root element
const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

// Send analytics data from web vitals
const sendToAnalytics = ({ name, delta, value, id }: any) => {
  const analyticsModule = import('./firebase/config');
  analyticsModule.then(({ logEvent }) => {
    logEvent('web_vitals', {
      // Google Analytics metrics must be integers, so the value is rounded
      value: Math.round(name === 'CLS' ? delta * 1000 : delta),
      // The metric name and value are passed to the event
      metric_id: id,
      metric_name: name,
      metric_value: value,
    });
  }).catch(console.error);
};

// Render the app
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(sendToAnalytics);
